// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__B5gsy","paramInput":"JobSimulator_paramInput__2gAZQ","input":"JobSimulator_input__3tIxz"};